export default __webpack_public_path__ + "static/media/1.990f5d61.jpg";